<template>
  <footer class="mdl-mega-footer">
    <div class="mdl-mega-footer__bottom-section">
      <ul class="mdl-mega-footer__link-list">
        <li><a href="//getquorum.com" target="_blank">About</a></li>
        <li><a href="//getquorum.com/privacy" target="_blank">Privacy</a></li>
        <li><a href="//getquorum.com/terms-of-use" target="_blank">Terms</a></li>
        <li><a href="mailto:contact@getquorum.com" target="_blank">Contact</a></li>
      </ul>
      <div class="mdl-layout-spacer"></div>
      <div class="commit-text">{{ commitCode }}</div>
    </div>
  </footer>
</template>

<script>
// // import api from 'src/api';

export default {
  computed: {
    commitCode() {
      return process.env.COMMIT_CODE;
    }
  },
  methods: {
  }
};
</script>

<style scoped>
.mdl-mega-footer__link-list a {
  font-size: 13px;
}
.mdl-mega-footer__link-list {
  margin-bottom:0px;
  padding:0px;
}
.mdl-mega-footer__bottom-section {
  display:flex;
}
.commit-text {
  font-size: 12px;
  color: rgba(158,158,158,0.1);
}
</style>
